import { createContext, useContext, ReactNode } from 'react';
import Teachr from '../Objects/models/Teachr';

export interface DashboardDataDispatch {
    currentPage: number;
    isData: boolean;
    type: string;
    setType: (type: string) => void;
    startTeachr: string;
    global: {
        teachr: Teachr | undefined;
        nameSearch: string;
        sort: { var: number; sort: number };
    };
}

export interface DashboardContextType {
    dataDispatch: DashboardDataDispatch;
}

const DashboardContext = createContext<DashboardContextType | null>(null);

export const useDashboardContext = () => {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error('useDashboardContext doit être utilisé à l\'intérieur d\'un DashboardProvider');
    }
    return context;
};

interface DashboardProviderProps {
    children: ReactNode;
    value: DashboardContextType;
}

export const DashboardProvider = ({ children, value }: DashboardProviderProps) => {
    return (
        <DashboardContext.Provider value={value}>
            {children}
        </DashboardContext.Provider>
    );
};
